/*eslint-disable */
import React, { Component } from "react";
import { Table, Button, Icon } from "semantic-ui-react";
import OrderDetails from "./orderDetails";
import { translate } from "react-i18next";
import FormikModalAllot from "../modals/interestedModal";
import ReadAxios from "../../axiosComponent/read";
import LoadingPlaceholder from "../../placeholderComponent/loadingPlaceholder";
import FormikModalVehicleDetail from "./vehicleDetails";
import ModalBroadCast from "../modals/modalBroadCast";
import CreateAxios from "../../axiosComponent/create";

export class ShipmentOrderTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openViewModal: false,
      order_fetch: null,
      currentOrder: 0,
    };
  }

  handleModelOpen = () => {
    this.setState({ openViewModal: true });
  };

  componentDidMount() {
    this.fetchOrderDetails();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentOrder !== this.state.currentOrder) {
      this.setState({ currentOrder: nextProps.currentOrder }, () =>
        this.fetchOrderDetails()
      );
    }
  }

  fetchOrderDetails = () => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${this.props.orderData.value}`,
    })
      .then((res) => {
        console.log("refetched order", res);
        this.setState({
          order_fetch: res.data.order,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  undoAllotToVendor = (order_id, vendor_id) => {
    CreateAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${order_id}/allocate/vendor/${vendor_id}/undo`,
    })
      .then((res) => {
        console.log('res>>', res);
        if (res.status == 200) {
          window.location.reload()
        }
      })
      .catch((err) => {
        console.log("shipment order failed >>> ", err.data);
      });
  };

  reloadCurrentPage = () => {
    this.props.history.go();
  };

  render() {
    const { t } = this.props;
    const { openViewModal, order_fetch } = this.state;
    return order_fetch ? (
      <>
        <Table className="w3-small" size="small" striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell className="p-bold-500">
                {t("table_header.order_no") || "Order Number"}
              </Table.HeaderCell>
              <Table.HeaderCell className="p-bold-500">
                {t("table_header.reference_no") || "Reference Number"}
              </Table.HeaderCell>
              <Table.HeaderCell className="p-bold-500">
                {t("table_header.gross_weight") || "Gross Weight"}
              </Table.HeaderCell>
              {(order_fetch.allotment_status &&
                order_fetch.allotment_status.allotment_code === "BRDCST") ? (<>
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.base_rate") || "Base Rate"}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.uom") || "UOM"}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.return_load") || "Return Load"}
                  </Table.HeaderCell>
                </>) :
                (null)}
              {/* <Table.HeaderCell className="p-bold-500">
                {t("table_header.net_weight") || "Net Weight"}
              </Table.HeaderCell> */}
              {order_fetch.vendor_name && (
                <Table.HeaderCell className="p-bold-500">
                  {t("table_header.vendor") || "Vendor"}
                </Table.HeaderCell>
              )}
              <Table.HeaderCell className="p-bold-500">
                {t("table_header.status") || "Status"}
              </Table.HeaderCell>
              <Table.HeaderCell className="p-bold-500">
                {t("table_header.view") || "View"}
              </Table.HeaderCell>
              {(order_fetch.allotment_status &&
                order_fetch.allotment_status.allotment_code === "REJECT") ||
                (!order_fetch.allotment_status && (
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.allot") || "Allot"}
                  </Table.HeaderCell>
                ))}
              {order_fetch.allotment_status && (!order_fetch.allotment_status ||
                order_fetch.allotment_status.allotment_code === "ALLOC" ||
                order_fetch.allotment_status.allotment_code ===
                "WAITINGVEH") && (
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.vehicle_details") || "Vehicle Details"}
                  </Table.HeaderCell>
                )}
              {(order_fetch.allotment_status &&
                order_fetch.allotment_status.allotment_code === "REJECT") ||
                (!order_fetch.allotment_status && (
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.broadcast") || "Broadcast"}
                  </Table.HeaderCell>
                ))}
            </Table.Row>
          </Table.Header>

          <Table.Body>
            <>
              <Table.Row>
                <Table.Cell>{order_fetch.order_no}</Table.Cell>
                <Table.Cell>{order_fetch.order_reference_no}</Table.Cell>
                <Table.Cell>{order_fetch.gross_weight}</Table.Cell>
                {(order_fetch.allotment_status &&
                  order_fetch.allotment_status.allotment_code === "BRDCST") ? (<>
                    <Table.Cell>{order_fetch.broadcast ? order_fetch.broadcast.base_rate : "NA"}</Table.Cell>
                    <Table.Cell>{order_fetch.broadcast ? order_fetch.broadcast.uom : "NA"}</Table.Cell>
                    <Table.Cell>{order_fetch.broadcast ? (order_fetch.broadcast.return_load ? "Yes" : "No") : "NA"}</Table.Cell>
                  </>) :
                  (null)}
                {/* <Table.Cell>{order_fetch.net_weight}</Table.Cell> */}
                {order_fetch.vendor_name && (
                  <Table.Cell>{order_fetch.vendor_name}</Table.Cell>
                )}
                <Table.Cell>
                  {order_fetch.allotment_status
                    ?
                    order_fetch.allotment_status.allotment_text
                    : "Created"} &nbsp;
                    {order_fetch.allotment_status && order_fetch.allotment_status.allotment_code == "WAITINGVEH" ? (
                    <Button
                      type="button"
                      onClick={() =>
                        this.undoAllotToVendor(
                          order_fetch.vendor_order_id,
                          order_fetch.vendor_id
                        )
                      }
                      size="mini"
                      basic color="primary"
                    // className="w3-blue w3-round w3-hover-blue"
                    >
                      {"undo"}
                    </Button>
                  ) : (
                      null
                    )}
                </Table.Cell>
                <Table.Cell>
                  <Button size="mini" basic color="primary" icon onClick={this.handleModelOpen}>
                    <Icon name="eye" />
                  </Button>
                </Table.Cell>
                {(order_fetch.allotment_status &&
                  order_fetch.allotment_status.allotment_code === "REJECT") ||
                  (!order_fetch.allotment_status && (
                    <Table.Cell>
                      <FormikModalAllot
                        order={order_fetch}
                        reFetchOrder={this.fetchOrderDetails}
                      />
                    </Table.Cell>
                  ))}
                {order_fetch.allotment_status && (!order_fetch.allotment_status ||
                  order_fetch.allotment_status.allotment_code === "ALLOC" ||
                  order_fetch.allotment_status.allotment_code ===
                  "WAITINGVEH") && (
                    <Table.Cell>
                      <FormikModalVehicleDetail
                        order={order_fetch}
                        order_id={order_fetch.vendor_order_id}
                        reFetchOrder={this.fetchOrderDetails}
                        allotment_status={order_fetch.allotment_status}
                      />
                    </Table.Cell>
                  )}
                {(order_fetch.allotment_status &&
                  order_fetch.allotment_status.allotment_code === "REJECT") ||
                  (!order_fetch.allotment_status && (
                    <Table.Cell>
                      <ModalBroadCast
                        order={order_fetch}
                        reFetchOrder={this.reloadCurrentPage}
                        shipmentId={this.props.shipmentId}
                      />
                    </Table.Cell>
                  ))}
              </Table.Row>
              {openViewModal && (
                <OrderDetails
                  movement_type={this.props.movement_type}
                  currenOrder={order_fetch}
                  OpenModal={openViewModal}
                  reFetchOrder={this.fetchOrderDetails}
                  CloseModal={() =>
                    this.setState({ openViewModal: false }, () =>
                      this.fetchOrderDetails()
                    )
                  }
                  size="large"
                />
              )}
            </>
          </Table.Body>
        </Table>
      </>
    ) : (
        <>
          <LoadingPlaceholder />
        </>
      );
  }
}

export default translate("order_list")(ShipmentOrderTable);
